import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { DataSourceState } from "abweb/dto/generated/ds/DataSourceState";
import { GraphicalDataSourceEdgeBase } from "abweb/dto/generated/gds/GraphicalDataSourceEdgeBase";
export class GraphicalDataSourceEdge extends GraphicalDataSourceEdgeBase {
  /**
   * Create an edge that connects two nodes together.
   * @param id The id of the edge. It's supposed to be unique across edges in a graph
   * @param node1 The "source" node
   * @param node2 The "destination" node
   * @param points The x,y coordinates of the start, end and bend points on the edge
   * @param midpoint
   */
  static createBetweenNodes(id, node1, node2, points, midpoint = null) {
    const retVal = new GraphicalDataSourceEdge();
    retVal.initGraphicalDataSourceEdge(null, id, null, DataSourceState.NORMAL, "", "", node2, midpoint, points, node1);
    return retVal;
  }
  constructor() {
    super();
    _defineProperty(this, "_width", void 0);
    _defineProperty(this, "_height", void 0);
  }
  get width() {
    if (this._width === undefined) {
      this.recomputeBoundingRect();
    }
    return this._width || 0;
  }
  get height() {
    if (this._height === undefined) {
      this.recomputeBoundingRect();
    }
    return this._height || 0;
  }
  recomputeBoundingRect() {
    if (!this.points) {
      return;
    }

    // The height/width of the edge... we need enough drawing room so that the edge doesn't get clipped when drawn.
    // Simply computing a bounding box from the points isn't good enough, because line styles might make the edge
    // thicker, and a head/tail marker might need more space. An old pattern used to be to let the container node's
    // bounding rectangle be the total available space to draw in. It's often WAY oversized for the edge, but the
    // edge should NEVER go outside the bounds of its containing node...
    //
    // Since we don't have access to the containing node here, this just adds the width/height by an arbitrary
    // amount to help mitigate the clipping.

    let width = 0;
    let height = 0;
    for (let index = 0; index < this.points.length; index++) {
      width = Math.max(width, this.points[index].x);
      height = Math.max(height, this.points[index].y);
    }
    this._width = width + 10;
    this._height = height + 10;
  }
}
//# sourceMappingURL=GraphicalDataSourceEdge.js.map
